import { ContentCopy } from "@mui/icons-material";
import { Box, Button, Stack, TextField as MuiTextField, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import { AdvancedConfirmDialog } from "components";
import { LangConstant } from "const";
import { useTranslation } from "react-i18next";
import { SystemUtils } from "utils";

const CopyPasswordDialog = ({ open, newPassword, onClose }) => {
  const { t: getLabel } = useTranslation();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(newPassword);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_COPY_SUCCESS), "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_COPY_FAILED), "error");
    }
  };

  return (
    <AdvancedConfirmDialog
      open={open}
      title={getLabel(LangConstant.TXT_COPY_PASSWORD_TITLE)}
      content={
        <Stack spacing={2}>
          <Box>
            <Typography fontSize={15} align="left">
              {getLabel(LangConstant.TXT_UPDATE_PASSWORD)}
            </Typography>
            <Typography fontSize={15} align="left">
              {getLabel(LangConstant.TXT_COPY_PASSWORD)}
            </Typography>
          </Box>

          <Stack width="100%" direction="row" spacing={1}>
            <TextField InputProps={{ readOnly: true }} defaultValue={newPassword} />
            <CopyButton variant="contained" title={getLabel(LangConstant.TXT_COPY_ACTION)} onClick={handleCopy}>
              <ContentCopy />
            </CopyButton>
          </Stack>
        </Stack>
      }
      submitProps={{ sx: { display: "none" } }}
      cancelProps={{ cancelText: getLabel(LangConstant.L_CLOSE), onClick: onClose }}
    />
  );
};

export default CopyPasswordDialog;

const TextField = styled(MuiTextField)({
  flexGrow: 1,
  "& .MuiInputBase-input": {
    padding: "10px 14px",
  },
});

const CopyButton = styled(Button)({
  width: 40,
  height: 40,
  minWidth: "unset",
});
